import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Calculator } from "lucide-react";

export const ROISettingsSection = ({ settings, onInputChange }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Calculator className="w-5 h-5" />
        Calculateur ROI
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="solution_price">Prix de la solution (CHF/mois)</Label>
        <Input
          id="solution_price"
          data-testid="admin-solution-price"
          type="number"
          min="0"
          value={settings.solution_price || 350}
          onChange={(e) => onInputChange("solution_price", parseInt(e.target.value) || 350)}
          placeholder="350"
        />
        <p className="text-xs text-muted-foreground">Ce prix sera utilise par defaut dans le calculateur ROI sur la page d'accueil</p>
      </div>
      <div className="bg-muted/50 rounded-lg p-4 text-sm text-muted-foreground">
        <p className="font-medium mb-2">Conseil :</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Ce prix s'affichera dans le calculateur ROI</li>
          <li>Les visiteurs peuvent le modifier pour tester differents scenarios</li>
          <li>La valeur par defaut est 350 CHF</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);
